import api from '@/api/index.js'

const role = {
  state: {
    loading: false,
    roles: [],
    // policyDetails lists available actions and resources
    // so we can build up-to-date RBAC forms
    policyDetails: {
      available_actions: [],
      available_resources: []
    },
    createdRole: {
      id: '',
      name: ''
    },
    error: null
  },

  mutations: {
    SET_ROLES_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ROLES: (state, roles) => {
      if (roles === undefined) {
        roles = []
      }
      state.roles = roles
      state.loading = false
    },
    SET_ROLE_POLICY_DETAILS: (state, policyDetails) => {
      state.policyDetails = policyDetails
    },
    SET_ROLE_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    },
    SET_CREATED_ROLE: (state, createdRole) => {
      state.createdRole = createdRole
    }
  },

  actions: {
    GetRoles({commit}) {
      commit('SET_ROLE_ERROR', null)
      commit('SET_ROLES', undefined)
      commit('SET_ROLES_LOADING', true)
      return api.get('roles?limit=150&offset=0')
        .then((response) => {
          commit('SET_ROLES', response)
        })
        .catch((error) => commit('SET_ERROR', error))
    },
    GetRolePolicyDetails({commit}) {
      return api.get('role-policy-details')
        .then((response) => {
          commit('SET_ROLE_POLICY_DETAILS', response)
        })
        .catch((error) => commit('SET_ERROR', error))
    },
    CreateRole({commit}, payload) {
      commit('SET_ERROR', null)
      return api.post(`roles`, payload)
        .then((response) => commit('SET_CREATED_ROLE', response.body))
        .catch((error) => commit('SET_ERROR', error.body))
    },
    DeleteRole({commit}, payload) {
      commit('SET_ERROR', null)
      return api.delete(`roles/${payload.id}`)
        .then((response) => commit('SET_ERROR', null))
        .catch((error) => commit('SET_ERROR', error))
    },
    AddRolePolicy({commit}, payload) {
      commit('SET_ERROR', null)
      return api.put(`roles/${payload.id}/add-policy`, payload)
        .then((response) => commit('SET_ERROR', null))
        .catch((error) => commit('SET_ERROR', error))
    },
    RemoveRolePolicy({commit}, payload) {
      commit('SET_ERROR', null)
      return api.put(`roles/${payload.id}/remove-policy`, payload)
        .then((response) => commit('SET_ERROR', null))
        .catch((error) => commit('SET_ERROR', error))
    }
  }
}

export default role
